<template>
    <div></div>
</template>

<script>

export default {
    name: `NotFound`,
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {
    }
}
</script>
